/* eslint-disable react-native/no-inline-styles */
import {useNavigation} from '@react-navigation/native';
import {Button, Layout, Text} from '@ui-kitten/components';
import React from 'react';
import {
  Image,
  StyleSheet,
  View,
  TouchableOpacity,
  Platform,
} from 'react-native';
import {getVersion} from 'react-native-device-info';
import {ScrollView} from 'react-native-gesture-handler';
import {starBanner} from '../../assets/images';
import {UN_AUTHENTICATED_ROUTES} from '../../navigation/constants';
import {isWebDesktopView, px} from '../../utils';

function WelcomeScreen() {
  const navigation = useNavigation();
  var isWebDesktop = isWebDesktopView();

  const appVersion = getVersion();

  return (
    <Layout style={styles.container}>
      <ScrollView contentContainerStyle={{flex: 1}}>
        <View
          style={{
            alignItems: 'center',
            marginTop: px(64),
            marginBottom: px(30),
          }}>
          <Image
            source={starBanner}
            resizeMode="contain"
            style={styles.image}
          />
        </View>
        <View>
          <View
            style={
              isWebDesktop
                ? {flexDirection: 'row', justifyContent: 'center'}
                : undefined
            }>
            <Button
              size="large"
              style={styles.loginButton}
              onPress={() =>
                navigation.navigate(UN_AUTHENTICATED_ROUTES.signUp.path)
              }>
              {'Register'}
            </Button>
            <Button
              size="large"
              appearance="outline"
              style={styles.loginButton}
              onPress={() =>
                navigation.navigate(UN_AUTHENTICATED_ROUTES.signIn.path)
              }>
              {'Log In'}
            </Button>
          </View>
          <TouchableOpacity
            onPress={() =>
              navigation.navigate(UN_AUTHENTICATED_ROUTES.contactUs.path)
            }>
            <Text style={styles.helpText} status="primary">
              {'Contact us'}
            </Text>
          </TouchableOpacity>

          {Platform.OS !== 'web' && (
            <Text style={styles.versionText}>{`v ${appVersion}`}</Text>
          )}
        </View>
      </ScrollView>
    </Layout>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: px(17),
  },
  loginButton: {
    marginTop: px(17),
    marginHorizontal: px(5),
    minWidth: px(150),
  },
  image: {
    width: px(250),
    height: px(250),
  },
  helpText: {
    marginVertical: px(17),
    width: '100%',
    textAlign: 'center',
    textDecorationLine: 'none',
  },
  versionText: {
    marginTop: 20,
    fontSize: px(12),
    width: '100%',
    textAlign: 'center',
  },
});

export default WelcomeScreen;
